import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Subtract } from '../../../assets/images/web-isn';
import { useLocation } from 'react-router-dom';
import { getLanguage } from '../../../utils/params';

const BreadcrumbFeaturedProjects = () => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());

  return (
    <React.Fragment>
      <div className="container px-0 mt-3">
        <div className="breadcrumb-container">
          <Link className="breadcrumb-home mr-3" to={`/${language}`}>
            {t('featured_projects_isn.label_breadcrumb_home')}
          </Link>
          <img src={Subtract} alt="subtract" />
          <div className="breadcrumb-service ml-3">
            &nbsp;{t('featured_projects_isn.label_breadcrumb_featured_projects')}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BreadcrumbFeaturedProjects;
